(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('os-printing-choice')) {
    customElements.define(
      'os-printing-choice',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized) return;
          this.dataset.initialized = 'true';
          const choices = this.querySelectorAll('input[name="attributes[Printing required]"]');
          const dyeContainer = this.querySelector('[data-printing-dye]');
          const dyeSelect = this.querySelector('[data-printing-dye-select]');
          const notApplicable = this.dataset.notApplicable;

          const update = () => {
            const selected = this.querySelector('input[name="attributes[Printing required]"]:checked');
            const printingRequired = selected && selected.value !== notApplicable && selected === choices[0];
            dyeContainer.hidden = !printingRequired;
            dyeSelect.required = Boolean(printingRequired);
            if (printingRequired && dyeSelect.value === notApplicable) dyeSelect.value = '';
            if (!printingRequired && selected) dyeSelect.value = notApplicable;
          };

          choices.forEach((choice) => choice.addEventListener('change', update));
          update();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-header-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__osMobileHeaderPolishReady) return;
    window.__osMobileHeaderPolishReady = true;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let originalParent;
    let originalNextSibling;

    const applyHeaderPolish = () => {
      const header = document.querySelector('header-component.header');
      const columns = header?.querySelector('.header__columns');
      const search = header?.querySelector('search-button.search-action--hidden-on-menu');

      if (!header || !columns || !search) return;

      if (!originalParent) {
        originalParent = search.parentNode;
        originalNextSibling = search.nextSibling;
      }

      if (mobileQuery.matches) {
        if (search.parentNode !== columns) columns.append(search);
        columns.classList.add('os-mobile-header-polished');
        search.style.setProperty('position', 'absolute', 'important');
        search.style.setProperty('top', '50%', 'important');
        search.style.setProperty('right', '14px', 'important');
        search.style.setProperty('bottom', 'auto', 'important');
        search.style.setProperty('left', 'auto', 'important');
        search.style.setProperty('z-index', '12', 'important');
        search.style.setProperty('display', 'flex', 'important');
        search.style.setProperty('transform', 'translateY(-50%)', 'important');
        return;
      }

      columns.classList.remove('os-mobile-header-polished');

      if (originalParent?.isConnected && search.parentNode !== originalParent) {
        if (originalNextSibling?.parentNode === originalParent) {
          originalParent.insertBefore(search, originalNextSibling);
        } else {
          originalParent.append(search);
        }
      }

      ['position', 'top', 'right', 'bottom', 'left', 'z-index', 'display', 'transform'].forEach((property) => {
        search.style.removeProperty(property);
      });
    };

    const initialise = () => {
      applyHeaderPolish();

      let attempts = 0;
      const hydrationCheck = window.setInterval(() => {
        applyHeaderPolish();
        attempts += 1;
        if (attempts >= 16) window.clearInterval(hydrationCheck);
      }, 250);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }

    mobileQuery.addEventListener('change', applyHeaderPolish);
    window.addEventListener('resize', applyHeaderPolish, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-shop-menu-fix"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__osMobileShopMenuFixReady) return;
    window.__osMobileShopMenuFixReady = true;

    let frame;

    const syncDrawerState = () => {
      if (frame) window.cancelAnimationFrame(frame);

      frame = window.requestAnimationFrame(() => {
        const container = document.querySelector('#Details-menu-drawer-container');
        const drawer = container?.querySelector('.menu-drawer');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const isOpen = Boolean(
          isMobile
          && container?.hasAttribute('open')
          && drawer
        );

        document.body.classList.toggle('os-mobile-menu-open', isOpen);
      });
    };

    const initialise = () => {
      const header = document.querySelector('header-component.header');

      syncDrawerState();

      if (!header) return;

      const observer = new MutationObserver(syncDrawerState);
      observer.observe(header, {
        attributes: true,
        attributeFilter: ['class', 'open'],
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }

    window.addEventListener('resize', syncDrawerState, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["os-product-buying-guide"] && !Shopify.designMode) return;
  try {
    function hydrateProductSizeCharts(root) {
    root.querySelectorAll('[data-os-product-buying]').forEach((guide) => {
      if (guide.hasAttribute('data-os-size-ready')) return;
      guide.setAttribute('data-os-size-ready', 'true');

      const title = guide.getAttribute('data-product-title') || '';
      const pattern = /(?:^|[^\d])(\d{2})\s*[-/xX]\s*(\d{2})\s*[-/xX]\s*(\d{3})(?=[^\d]|$)/g;
      let match;
      let dimensions;

      while ((match = pattern.exec(title)) !== null) {
        dimensions = {
          lens: Number(match[1]),
          bridge: Number(match[2]),
          temple: Number(match[3])
        };
      }

      if (!dimensions) return;
      if (dimensions.lens < 35 || dimensions.lens > 75) return;
      if (dimensions.bridge < 10 || dimensions.bridge > 35) return;
      if (dimensions.temple < 100 || dimensions.temple > 170) return;

      Object.entries(dimensions).forEach(([key, value]) => {
        const target = guide.querySelector(`[data-os-size-value="${key}"]`);
        if (target) target.textContent = String(value);
      });

      const chart = guide.querySelector('[data-os-frame-size]');
      if (chart) chart.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateProductSizeCharts(document));
  } else {
    hydrateProductSizeCharts(document);
  }

  document.addEventListener('shopify:section:load', (event) => hydrateProductSizeCharts(event.target));
  } catch(e) { console.error(e); }
})();

})();
